export default "__VITE_ASSET__V39EIjQ4__"